// engine
import { ArController, delay, gameDispatcher, soundService } from '@aceroll/core';

// hacksaw
import { uiService } from '@aceroll/platform-hacksaw';

import { platform } from '../../platform';

export class RoundCompleted extends ArController {
	constructor() {
		super();

		this.onUiStateChange = this.onUiStateChange.bind(this);
		this.onAutoplayRoundStart = this.onAutoplayRoundStart.bind(this);
	}

	async onStart() {
		platform.onceRoundEnded().then(this.playFirmSound);

		const { multiplierPanel } = this.context.currentLayout;
		multiplierPanel.reset();

		await delay(150);

		platform.setGameRoundCompleted();

		// Debug DB
		// this.context.currentLayout.multiplierPanel.hide();

		uiService.onStateChange(this.onUiStateChange);
		uiService.onAutoplayRoundStarted(this.onAutoplayRoundStart);
	}

	async playFirmSound(roundData) {
		const { cheapSounds } = gameDispatcher.state.jurisdictionConfig;

		const { bet } = gameDispatcher.state;
		const win = +roundData.win;


		if (!win) {
			return;
		}

		const cheapWin = win <= bet;

		if (cheapWin && cheapSounds) {
			return;
		}

		soundService.play('firm_sound');
	}

	// events
	onAutoplayRoundStart() {
		this.stop();
	}

	async onUiStateChange(state) {
		if (state.current === 'idle') {
			this.stop();
		}
	}
	onStop() {
		uiService.offStateChange(this.onUiStateChange);
		uiService.offAutoplayRoundStarted(this.onAutoplayRoundStart);
	}
}
